module.exports = __webpack_public_path__ + "static/media/2-questa_grande_regular_31-webfont.316464bd.woff2";